import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme=>({
    colorComponente:{
        backgroundColor: 'white',
        alignItems: "center",
        borderRadius: 20,
        flexFlow: "row-wrap",
        ['@media (max-width:415px)']:{ //mobile
            marginBottom: 10,
        },
        ['@media (max-width:320px)']:{ //mobile
            marginBottom: 10,
        }                
    },

    lineaDegradadaBottom:{
        position: "relative",
        bottom: 0,
        left: 0,
        width: "100%",
        height: 4,
        background: `linear-gradient(344deg, rgba(2,0,36,1) 0%, rgba(9,9,121,1) 35%, rgba(0,212,255,1) 100%)`,
    },
    centerTitle: {
        textAlign: 'center',
        // marginTop: '10px',
        // marginBottom: '10px',
        backgroundColor:'gainsboro',
    },        
	input: {
		display: 'none',
	},     
	label: {
		// width: "80%",
		display: "flex",
		justifyContent: "center",
		alignItems: 'center'
	  },
	imageUpload: {
		background: 'linear-gradient(45deg, #2196F3 30%, #21CBF3 90%)',
        border: 0,
		borderRadius: 3,
		boxShadow:'0 3px 5px 2px rgba(119, 241, 255)',
		color: 'white',
        height: 37,
		padding: '5px 30px',
        margin: theme.spacing(1),
		textAlign: "center",
		// textTransform: 'uppercase',
		cursor: "pointer",
		// width: "200px",
		fontSize: '16px',
	  },    
    root: {
		flexGrow: 1,
	},
	title: {
		flexGrow: 1,
	},	
	menuButton: {
		marginRight: theme.spacing(2),
	},
	icon: {
		color: 'white',
	},
	appBar: {
		backgroundColor: '#01579B',
	},
	button: {
		color: 'white',
	},
	gridIframe :{
		height: '512px',
	}
}))